var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuitemBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "27px",
    viewBox: "0 0 31 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A6F6E6BD-23C7-4750-99DD-F2EFB3DB623F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone---RYSST---concept---full-menu---new-3",
    transform: "translate(-352.000000, -41.000000)",
    stroke: "#121212",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(353.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.58,
    y1: 0.58,
    x2: 28.42,
    y2: 0.58,
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.58,
    y1: 24.94,
    x2: 28.42,
    y2: 24.94,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.58,
    y1: 13.34,
    x2: 22.62,
    y2: 13.34,
    id: "Line"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuitemBlack);
export default __webpack_public_path__ + "static/media/menuitem-black.f46b09a483865243a64ef1418b38f819.svg";
export { ForwardRef as ReactComponent };